import { render, staticRenderFns } from "./billing-data-form.vue?vue&type=template&id=a3874dd0&lang=pug"
import script from "./billing-data-form.vue?vue&type=script&lang=ts"
export * from "./billing-data-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports